"use strict";

class CampaignScheduleCtrl {

    constructor(zoomFactor, $scope, $http, moment, $timeout, $rootScope, $location, $state, itemData, $transitions, Campaign) {

        // Dependencies
        this.$scope = $scope;
        this.$http = $http;
        this.$moment = moment;
        this.$timeout = $timeout;
        this.$rootScope = $rootScope;
        this.$location = $location;
        this.$state = $state;
        this.itemData = itemData;
        this._Campaign = Campaign;

        // Properties
        this.loaded = false;
        this.data = [];
        this.zoomFactor = zoomFactor;
        this.zoomFactorDebounce = null;
        this.refresh = false;
        this.hours = this.generateHours();
        this.customFields = {};

        this.id = $state.params.id;
        this.formdata = $state.params.campaign;

        this.unregister = $transitions.onSuccess({}, function (transition) {

            let to = transition.to();
            let from = transition.from();

            //go back to campaign details if there is no title set (instead of to the schedule)
            if (from.url === '/item' && to.url === '/schedule') {
                if (this.formdata && !this.formdata.item.title) {
                    $timeout(() => {
                        return $state.go('^');
                    }, 200);
                }
            }
        }.bind(this));

        if (!this.formdata) {
            this.getCampaignData();
            // return $state.go('^');
        } else if (!this.formdata.item.title) {
            if (angular.equals(this.itemData.getItemObj(), {})) {
                this.itemData.setItemObj({
                    title: this.formdata.title,
                    details: this.formdata.description,
                });
            }

            $state.go('.item');
        }

        this.formdata.item_count = this.formdata.item_count || 0;

        // Init
        this.$timeout(() => {
            this.fetch();
            this.updateZoom();
        });

        // Watchers
        this.$scope.$watch(() => this.zoomFactor, () => {
            this.updateZoom();
        });

        this.$scope.$on('$destroy', () => {

            this.unregister();
        });

        this.additions = {
            add: this.formdata.added_items || [],
            remove: this.formdata.removed_items || []
        };

        this._addToBlock = this.addToBlock.bind(this);
        this._subtractFromBlock = this.subtractFromBlock.bind(this);
    }

    updateZoom() {
		$('.TimeTime').css({
			height: ((70 / 100) * this.zoomFactor) + 'px',
		});
	}

    getCampaignData() {
        this.formdataCopy = null;
        this.formdata = {
            item: {},
            recommended: true,
        };

        this.getModelTypes().then(() => {
            if (this.customFieldsRaw.length < 2) {
                this.formdata.model_type_id = this.customFieldsRaw[0].id;
            }

            if (this.id) {
                this._Campaign.get({id: this.id}, (data) => {

                    delete data.$promise;

                    angular.extend(this.formdata, data);
                    this.formdata.model_type_id = data.model_type_id;
                    this.fixDates();

                    this.itemData.setItemObj(this.formdata.item);
                    this.itemData.notify('item');

                    //Copy dataform so we can reverse the data on cancel
                    this.formdataCopy = angular.copy(this.formdata);
                });

                this.fetchItems(this.id);
            } else {
                // default type
                this.itemData.setItemObj({});
                this.formdata.model_type_id = this.customFieldsRaw[0].id;
            }
        });
    }

    fixDates() {

        if (this.formdata.start) {
            this.formdata.start = new Date(this.formdata.start);
        }
        if (this.formdata.stop) {
            this.formdata.stop = new Date(this.formdata.stop);
        }
    }

    fetchItems(campaignId) {
        this.$http.get('items/campaign/' + campaignId).then((response) => {
            this.items = response.data;
            this.stationId = window.CONFIG.station_id;
        });
    }

    getModelTypes() {
        // We need these for scheme
        this.$http.get('/modeltypes/item', {cache: true}).then((response) => {
            this.itemCustomFieldsRaw = response.data.item;
            this.formdata.item_model_type = this.itemCustomFieldsRaw[0].id;
        });
        return this.$http.get('/modeltypes/campaign', {cache: true}).then((response) => {
            this.customFieldsRaw = response.data.campaign;
            response.data.campaign.forEach((data) => {
                this.customFields[data.id] = data.fields;
            });
            return response.data;
        });
    }

    openItem($e) {
        this.$state.go('.item');
    }

    contains(arr, id) {
        let i = arr.indexOf(id);
        return i > -1 ? i : false;
    }

    addToBlock(block_id) {
        let i = this.contains(this.additions.remove, block_id);
        if (i !== false) {
            this.additions.remove.splice(i, 1);
        } else {
            this.additions.add.push(block_id);
        }
    }

    subtractFromBlock(block_id) {
        let i = this.contains(this.additions.add, block_id);
        if (i !== false) {
            this.additions.add.splice(i, 1);
        } else {
            this.additions.remove.push(block_id);
        }
    }

    save() {
        this.$rootScope.$broadcast('campaign_save_schedule', {
            add_items: this.additions.add,
            remove_items: this.additions.remove
        });
        this.$state.go('^');
    }

    cancel() {
        this.$state.go('^');
    }

    fetch(url) {
        if (!url) {
            let start = this.$moment(this.formdata.start);
            url = '/campaigns/week/' + start.format('YYYY-MM-DD');
        }

        this.loaded = false;
        this.$http.get(url).then((response) => {
            this.data = response.data;

            let start = moment(this.formdata.start).hour(0);
            let stop = moment(this.formdata.stop).hour(0);
            let s = Object.keys(this.data.days)
                .filter((key) => {
                    let day = moment(key);
                    return day < start || day > stop;
                })
                .map((key) => this.data.days[key])
                .reduce((a, b) => a.concat(b), [])
                .forEach((block) => {
                    block._inactive = true;
                });

            this.date = new Date(response.data.start);
            this.loaded = true;

            this.$timeout(() => {
                $('.TimeTime').css({
                    height: ((70 / 100) * this.zoomFactor) + 'px'
                });
                this.refresh = !this.refresh;
            });
        });
    }

    fetchCurrentWeek() {
        let start = this.$moment();
        let url = '/campaigns/week/' + start.format('YYYY-MM-DD');
        this.fetch(url);
    }

    pickDate() {
        let start = this.$moment(this.date);
        let url = '/campaigns/week/' + start.format('YYYY-MM-DD');
        this.fetch(url);
    }

    saveZoomFactor() {
        if (this.zoomFactorDebounce) {
            clearTimeout(this.zoomFactorDebounce);
        }
        this.zoomFactorDebounce = setTimeout(() => {
            this.$http.post('/usersettings', {
                zoomFactor: this.zoomFactor
            });
        }, 1000);
    }

    // Get 24 hours
    generateHours() {

        var hours = [];

        for (let i = 0; i < 24; i++) {

            let format = (i < 10) ? '0' + i : i;

            format += ':00';

            hours.push(format);
        }

        return hours;
    }
}

CampaignScheduleCtrl.$inject = ['zoomFactor', '$scope', '$http', 'moment', '$timeout', '$rootScope', '$location', '$state', 'itemData', '$transitions', 'Campaign'];

module.exports = CampaignScheduleCtrl;
